<template>
  <div>
    <div align="left">
      <br />
      <h5 class="font-weight-bold text-primary">Frequently Asked Question</h5>
      <br />
    </div>
    <b-card class="text-left">
      <b>Create New Frequently Asked Question</b>

      <b-row class="mt-4">
        <b-col md="6">
          <b-form-group
            id="input-group-1"
            label-class="control-label mb-n1"
            label="Image"
            label-for="input-1"
          ></b-form-group>
          <b-card body-class="py-2 px-2">
            <card-body>
              <b-row>
                <b-col class="text-primary mt-2">
                  <i class="fas fa-paperclip"></i>&nbsp;
                  <b>{{image.name || 'Name'}}</b>
                  <sup class="text-secondary pl-3">(2 Mb)&nbsp;(1000px x 400px)</sup>
                </b-col>
                <b-col md="4" class="text-right" align="right">
                  <input
                    type="file"
                    ref="image"
                    name="image"
                    v-validate="'image|minimalDimensions:1000,400|size:2000|ext:jpg,png,gif,jpeg'"
                    style="display: none"
                    v-on:change="onChangeimage()"
                  />
                  <b-button
                    @click="$refs.image.click()"
                    v-show="!image"
                    variant="primary"
                    class="ml-5"
                  >Select File</b-button>
                  <b-button
                    v-show="image"
                    variant="primary"
                    @click="modalImage = !modalImage"
                    class="mr-2"
                  >Preview</b-button>
                  <b-button
                    @click="$refs.image.click()"
                    v-show="image"
                    variant="outline-primary"
                    class
                  >Change File</b-button>
                </b-col>
              </b-row>
            </card-body>
          </b-card>
          <p
            class="text-danger"
            style="width:100%;margin-top:.25rem;font-size: 80%;"
          >{{ veeErrors.first('image') }}</p>
        </b-col>
        <b-col md="6">
          <b-form-group
            id="fieldset-1"
            label-class="control-label"
            class="required"
            label="Category (Bahasa)"
            label-for="input-1"
          >
            <select
              class="custom-select mt-2"
              v-validate="'required'"
              data-vv-as="Category"
              name="category"
              v-model="selected"
              required
            >
              <option value>Select Category</option>
              <option v-for="item in items" :key="item" :value="item.id">{{item.category_name.id}}</option>
            </select>
            <b-form-invalid-feedback id="input-live-feedback">{{ veeErrors.first('category') }}</b-form-invalid-feedback>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <b-form-group
            id="fieldset-1"
            label="Question (Bahasa)"
            label-class="control-label"
            class="required"
            label-for="input-1"
          >
            <input
              placeholder="Question in Bahasa Indonesia"
              v-model="question_id"
              v-validate="'required'"
              data-vv-as="Question Bahasa"
              name="question_id"
              class="form-control"
            />
            <b-form-invalid-feedback
              id="input-question_id-feedback"
            >{{ veeErrors.first('question_id') }}</b-form-invalid-feedback>
          </b-form-group>
        </b-col>
        <b-col>
          <b-form-group
            id="fieldset-1"
            label="Question (English)"
            label-class="control-label"
            class="required"
            label-for="input-1"
          >
            <input
              placeholder="Question in English"
              v-model="question_en"
              v-validate="'required'"
              data-vv-as="Question English"
              name="question_en"
              class="form-control"
            />
            <b-form-invalid-feedback
              id="input-question_en-feedback"
            >{{ veeErrors.first('question_en') }}</b-form-invalid-feedback>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <b-form-group
            id="fieldset-1"
            label="Answer (Bahasa)"
            label-class="control-label"
            class="required"
            label-for="input-1"
          >
            <ckeditor
              :editor="editor"
              placeholder="Answer in Bahasa"
              v-model="answer_id"
              class="form-control ck-editor__editable ck-editor__editable_inline"
              :config="editorConfig"
              data-vv-as="Answer Bahasa"
              v-validate="'required'"
              name="answer_id"
            ></ckeditor>
            <p
              class="text-danger"
              style="width:100%;margin-top:.25rem;font-size: 80%;"
            >{{ veeErrors.first('answer_id') }}</p>
          </b-form-group>
        </b-col>
        <b-col>
          <b-form-group
            id="fieldset-1"
            label="Answer (English)"
            label-class="control-label"
            class="required"
            label-for="input-1"
          >
            <ckeditor
              :editor="editor"
              placeholder="Answer in English"
              v-model="answer_en"
              class="form-control ck-editor__editable ck-editor__editable_inline"
              :config="editorConfig"
              data-vv-as="Answer English"
              v-validate="'required'"
              name="answer_en"
            ></ckeditor>
            <p
              class="text-danger"
              style="width:100%;margin-top:.25rem;font-size: 80%;"
            >{{ veeErrors.first('answer_en') }}</p>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <b-form-group
            id="input-group-1"
            class="required"
            label-class="control-label"
            label="Meta Description Bahasa"
            label-for="input-1"
          >
            <textarea
              id="input-1"
              type="text"
              class="form-control"
              v-validate="{required: true, max: 159}"
              name="meta_description_id"
              data-vv-as="Meta Description Bahasa"
              v-model="meta_description_id"
              placeholder="Meta Description Bahasa"
              style="height: 70px"
            />
            <b-form-invalid-feedback
              id="input-meta_description_id-feedback"
            >{{ veeErrors.first('meta_description_id') }}</b-form-invalid-feedback>
          </b-form-group>
        </b-col>
        <b-col>
          <b-form-group
            id="input-group-1"
            class="required"
            label-class="control-label"
            label="Meta Description English"
            label-for="input-1"
          >
            <textarea
              id="input-1"
              type="text"
              class="form-control"
              v-validate="{required: true, max: 159}"
              name="meta_description_en"
              data-vv-as="Meta Description English"
              v-model="meta_description_en"
              placeholder="Meta Description English"
              style="height: 70px"
            />
            <b-form-invalid-feedback
              id="input-meta_description_en-feedback"
            >{{ veeErrors.first('meta_description_en') }}</b-form-invalid-feedback>
          </b-form-group>
        </b-col>
      </b-row>
      <br />
      <div class="form-group required font-weight-bold">
        <label class="control-label"></label>
        Required
      </div>
      <b-row class="text-right">
        <b-col>
          <b-button
            variant="primary"
            :disabled="loading"
            @click="post()"
            class="mr-3"
            size="lg"
          >Create</b-button>
          <router-link :to="{name: 'FaqContent'}">
            <b-button variant="outline-secondary" size="lg">Cancel</b-button>
          </router-link>
        </b-col>
      </b-row>
    </b-card>
    <b-modal v-model="modalImage" title="Preview Image" size="xl">
      <img v-if="urlImage" width height="400px" :src="urlImage" />
    </b-modal>
  </div>
</template>

<script>
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import { mixInCkeditor } from "@/mixin/mixInCkeditor";
export default {
  mixins: [mixInCkeditor],
  data() {
    return {
      editor: ClassicEditor,
      editorConfig: {},
      selected: "",
      isHiddenEnglish: false,
      isHiddenBahasa: false,
      title: "",
      question_id: "",
      question_en: "",
      answer_id: "",
      answer_en: "",
      meta_description_id: "",
      meta_description_en: "",
      loading: false,
      modalImage: false,
      widthImage: null,
      heightImage: null,
      urlImage: "",
      image: "",
      items: []
    };
  },
  methods: {
    post() {
      this.$validator.validateAll().then(result => {
        if (result) {
          this.loading = true;
          const formData = new FormData();
          formData.append("category_id", this.selected);
          formData.append("question_id", this.question_id);
          formData.append("question_en", this.question_en);
          formData.append("answer_id", this.answer_id);
          formData.append("answer_en", this.answer_en);
          formData.append("meta_description_id", this.meta_description_id);
          formData.append("meta_description_en", this.meta_description_en);
          formData.append("image", this.image);
          this.$store
            .dispatch("FaqModule/postFaq", formData)
            .then(response => {
              this.loading = false;
              this.$router.push({ name: "FaqContent" });
              this.$swal({
                type: "success",
                title: "Your work has been saved",
                showConfirmButton: false,
                timer: 1500
              });
              console.log(response);
            })
            .catch(error => {
              this.loading = false;
              this.serverError = error.response.data;
              this.$swal({
                type: "error",
                title: "Oops...",
                text: error.response.data,
                showConfirmButton: false,
                timer: 1500
              });
              console.log(error);
            });
        } else {
          this.$swal({
            type: "error",
            title: "Oops...",
            text: this.$validator.errors.all(),
            showConfirmButton: false,
            timer: 1500
          });
        }
      });
    },
    onChangeimage() {
      this.image = this.$refs.image.files[0];
      const input = this.$refs.image;
      const { files } = input;
      if (files && files[0]) {
        const reader = new FileReader();
        reader.onload = e => {
          const img = new Image();
          img.onload = () => {
            this.widthImage = img.width;
            this.heightImage = img.height;
          };
          img.src = e.target.result;
          this.urlImage = e.target.result;
        };
        reader.readAsDataURL(files[0]);
        this.$emit("input", files[0]);
      }
    }
  },
  async beforeCreate() {
    this.$store.dispatch("FaqModule/getFaqCategoryDatas", { root: true });
  },
  created() {
    this.$store.watch(
      state => state.FaqModule.faq_category,
      (newValue, oldValue) => {
        this.items = newValue;
        // Do whatever makes sense now
        if (this.items.length === 0) {
          this.loading = true;
        } else {
          this.loading = false;
        }
      }
    );
  }
};
</script>

<style>
.ck-editor__editable_inline {
  min-height: 200px;
}
</style>
